export default __webpack_public_path__ + "static/media/Ekk.20d00149.png";